import {
  getSupplierVideoEmbedUrl,
  getSupplierVideoThumbnail,
  getSupplierVideoWatchUrl,
} from '@bridebook/web/lib/supplier/video';

// Removes common markdown so description is plain text as schema.org expects.
const stripMarkdown = (s: string) =>
  s
    .replace(/#{1,6}\s*/g, '')
    .replace(/(\*\*|__)(.*?)\1/gs, '$2')
    .replace(/(\*|_)(.*?)\1/gs, '$2')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/^[-*]\s+/gm, '')
    .trim();

/**
 * https://schema.org/VideoObject
 * https://developers.google.com/search/docs/appearance/structured-data/video
 */
interface IVideoObjectMicrodata {
  '@context': 'https://schema.org';
  '@type': 'VideoObject';
  name: string;
  description?: string;
  thumbnailUrl: string;
  uploadDate: string;
  duration?: string;
  contentUrl: string;
  embedUrl: string;
}

interface IArgs {
  name: string;
  description: string;
  videoId: string;
  uploadDate: string;
  /** ISO 8601 duration, e.g. PT3M42S. Omitted from output when empty. */
  duration?: string;
  thumbnailUrl?: string;
}

export const generateVideoObjectMicrodata = ({
  name,
  description,
  videoId,
  uploadDate,
  duration,
  thumbnailUrl,
}: IArgs): IVideoObjectMicrodata | null => {
  if (!uploadDate) return null;

  const data: IVideoObjectMicrodata = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name,
    thumbnailUrl: thumbnailUrl || getSupplierVideoThumbnail(undefined, videoId, 'maxresdefault'),
    uploadDate,
    contentUrl: getSupplierVideoWatchUrl(videoId),
    embedUrl: getSupplierVideoEmbedUrl(videoId),
  };

  if (description) {
    data.description = stripMarkdown(description);
  }

  if (duration) {
    data.duration = duration;
  }

  return data;
};
